<template>
  <form @submit.prevent="saveAction" class="main-modal main-form main-modal_w500">
    <div class="main-modal__title main-modal__title_mb32">
      <p>Tag bearbeiten</p>
    </div>

    <div class="main-form__box main-form__box_flex main-form__box_between">
      <div class="main-form__half main-form__half_first">
        <label class="main-form__label">Arbeitszeit von</label>

        <el-select
          v-model="schedule.from"
          placeholder="Select"
          class="schedule-period__select mb-12"
        >
          <el-option
            v-for="item in timeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <div class="main-form__half main-form__half_second">
        <label class="main-form__label">bis</label>
        <el-select v-model="schedule.to" placeholder="Select" class="schedule-period__select">
          <el-option
            v-for="item in timeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>

    <div class="main-form__buttons main-form__buttons_center">
      <span @click="$emit('close')" class="main-button main-button_cancel">
        {{
        $t("global.cancel")
        }}
      </span>
      <button type="submit" class="main-button main-button_success">{{ $t("global.save") }}</button>
    </div>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: {
        params: {
            required: true,
        },
    },
    data() {
        return {
            timeOptions: [
                { value: '00:00', label: '00:00' },
                { value: '01:00', label: '01:00' },
                { value: '02:00', label: '02:00' },
                { value: '03:00', label: '03:00' },
                { value: '04:00', label: '04:00' },
                { value: '05:00', label: '05:00' },
                { value: '06:00', label: '06:00' },
                { value: '07:00', label: '07:00' },
                { value: '08:00', label: '08:00' },
                { value: '09:00', label: '09:00' },
                { value: '10:00', label: '10:00' },
                { value: '11:00', label: '11:00' },
                { value: '12:00', label: '12:00' },
                { value: '13:00', label: '13:00' },
                { value: '14:00', label: '14:00' },
                { value: '15:00', label: '15:00' },
                { value: '16:00', label: '16:00' },
                { value: '17:00', label: '17:00' },
                { value: '18:00', label: '18:00' },
                { value: '19:00', label: '19:00' },
                { value: '20:00', label: '20:00' },
                { value: '21:00', label: '21:00' },
                { value: '22:00', label: '22:00' },
                { value: '23:00', label: '23:00' },
            ],
            // schedule: {
            // from: null,
            // to: null
            //   // time_extra_price_1: {
            //   //   from: null,
            //   //   to: null,
            //   // },
            //   // time_extra_price_2: {
            //   //   from: null,
            //   //   to: null,
            //   // },
            // }
        }
    },
    computed: {
        ...mapGetters({
            schedule: 'specialists/editSchedule',
        }),
        // checkIsValid() {
        //   if (this.schedule.time_base_price.from == null) return false;
        //   if (this.schedule.time_base_price.to == null) return false;

    //   return true;
    // },
    },
    methods: {
        ...mapActions({
            editClientSchedule: 'editClientSchedule',
        }),
        prepareForm() {
            return {
                ...this.schedule,
            }
        },
        saveAction() {
            this.$emit('save', this.schedule)
        },
    },
    // mounted() {
    // this.schedule = {
    //   ...this.schedule,
    //   ...this.params
    // };
    // }
}
</script>
